import React from 'react'
import PropTypes from 'prop-types'
import { Editor } from '@tinymce/tinymce-react'

import 'tinymce/tinymce'
import 'tinymce/models/dom/model'
import 'tinymce/themes/silver'
import 'tinymce/icons/default'

import 'tinymce/skins/ui/oxide/skin.min.css'

import 'tinymce/plugins/lists'
import 'tinymce/plugins/code'

import { EDITOR_INIT } from './editorInit'

export default function AgreementContentEditor ({
  id,
  value,
  onChange,
  onBlur,
  disabled
}) {
  return (
    <Editor
      id={id}
      value={value}
      disabled={disabled}
      onEditorChange={onChange}
      onBlur={onBlur}
      init={EDITOR_INIT}
    />
  )
}

AgreementContentEditor.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}
